/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Feature_Support_DedicatedInputs */

const en_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedicated Support`)
};

const es_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte dedicado`)
};

const fr_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Dédié`)
};

const de_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedizierter Support`)
};

const ja_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`専用サポート`)
};

const zh_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专属客服支持`)
};

const ar_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعم مخصص`)
};

const id_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukungan Dedikasi`)
};

const it_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto Dedicato`)
};

const ru_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выделенная поддержка`)
};

const pt_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporte Dedicado`)
};

const ko_tier_feature_support_dedicated = /** @type {(inputs: Tier_Feature_Support_DedicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전담 지원`)
};

/**
* | output |
* | --- |
* | "Dedicated Support" |
*
* @param {Tier_Feature_Support_DedicatedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_feature_support_dedicated = /** @type {((inputs?: Tier_Feature_Support_DedicatedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Feature_Support_DedicatedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_feature_support_dedicated(inputs)
	if (locale === "es") return es_tier_feature_support_dedicated(inputs)
	if (locale === "fr") return fr_tier_feature_support_dedicated(inputs)
	if (locale === "de") return de_tier_feature_support_dedicated(inputs)
	if (locale === "ja") return ja_tier_feature_support_dedicated(inputs)
	if (locale === "zh") return zh_tier_feature_support_dedicated(inputs)
	if (locale === "ar") return ar_tier_feature_support_dedicated(inputs)
	if (locale === "id") return id_tier_feature_support_dedicated(inputs)
	if (locale === "it") return it_tier_feature_support_dedicated(inputs)
	if (locale === "ru") return ru_tier_feature_support_dedicated(inputs)
	if (locale === "pt") return pt_tier_feature_support_dedicated(inputs)
	return ko_tier_feature_support_dedicated(inputs)
});